import * as React from 'react';
import { Experiment } from './types';

export const ExperimentContext = React.createContext<Experiment>({});
ExperimentContext.displayName = 'ExperimentContext';
